
import NoteCreationEditionMaxView from "./NoteCreationEditionMaxView";

export default NoteCreationEditionMaxView;